export default __webpack_public_path__ + "static/media/024-strawberry.9273b3bb.svg";